import { useTranslation } from 'react-i18next';

import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { Link } from '@remix-run/react';
import cx from 'classnames';

import Typography from '~/components/Typography';

interface Props {
  ctaText?: string;
  fontFamily?: any;
  fontSize?: any;
}

const PostsCTA = ({ ctaText, fontFamily, fontSize }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="pt-4">
      <Link
        to={'/'}
        prefetch="intent"
        className="duration:300 text-md group inline-flex cursor-pointer items-center no-underline transition"
      >
        <Typography
          as="span"
          size={fontSize}
          weight="regular"
          fontFamily={fontFamily}
          className={cx({
            'mr-1.5 opacity-75 transition duration-200 group-hover:opacity-100': true,
          })}
        >
          {ctaText || t('subscribe.read')}
        </Typography>
        <ArrowRightIcon className="mt-0.5 h-4 w-4 w-auto opacity-75 transition duration-200 group-hover:opacity-100" />
      </Link>
    </div>
  );
};

export default PostsCTA;
